import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Modal from 'components/modal_wrapper';

const ErrorDialog = ({ id, children, title, show, handleClose }) => (
  <Modal id={id} show={show} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>{title || 'Error'}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{children}</Modal.Body>
    <Modal.Footer>
      <Button variant="primary" className="w-100" onClick={handleClose}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ErrorDialog;

ErrorDialog.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
